<template>
    <div id="tag-chip-component">
        <v-sheet :color="tagReferentiel.color" class="font-14 duration-400 transition-all rounded">
            <div class="d-flex justify-content-between align-center fill-height text-no-wrap">
                <div
                    :class="`d-flex flex-grow-1 px-3 ${size === 'small' ? 'py-1' : 'py-2'} gap-2 align-center min-w-0`"
                    @click="$emit('click:body')"
                >
                    <v-icon v-if="tagReferentiel.icon"> mdi-{{ tagReferentiel.icon }}</v-icon>
                    <div class="text-truncate">
                        <span
                            v-if="$t(`tag_chip_component.${tagReferentiel.label}`) !== `tag_chip_component.${tagReferentiel.label}`"
                            :class="!isDarkColorToContrastWithBackgroundColor(tagReferentiel.color) ? 'font-color-normal' : 'white--text'"
                        >
                            {{ $t('tag_chip_component.' + tagReferentiel.label) }}
                        </span>
                        <span
                            v-else
                            :class="!isDarkColorToContrastWithBackgroundColor(tagReferentiel.color) ? 'font-color-normal' : 'white--text'"
                        >
                            {{ $t(tagReferentiel.label) }}
                        </span>
                    </div>
                </div>

                <slot name="append-inner" />
            </div>
        </v-sheet>
    </div>
</template>

<script>
export default {
    props: {
        tagReferentiel: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            required: false,
        },
    },
    methods: {
        isDarkColorToContrastWithBackgroundColor(backgroundColor) {
            let r, g, b, hsp
            if (backgroundColor.match(/^rgb/)) {
                backgroundColor = backgroundColor.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)
                r = backgroundColor[1]
                g = backgroundColor[2]
                b = backgroundColor[3]
            } else {
                backgroundColor = +('0x' + backgroundColor.slice(1).replace(backgroundColor.length < 5 && /./g, '$&$&'))
                r = backgroundColor >> 16
                g = (backgroundColor >> 8) & 255
                b = backgroundColor & 255
            }
            hsp = 0.299 * r + 0.587 * g + 0.114 * b

            return hsp > 127.5
        },
    },
}
</script>
